import { z } from 'zod';
import { TypedApiClient } from '../index';
import { apiPath } from '../path';

// Zod schemas for Product Tags API
export const ProductTagResponseSchema = z.object({
  id: z.string(),
  firestore_id: z.string().optional().nullable(),
  name: z.string(),
  color: z.string().optional().nullable(),
  icon: z.string().optional().nullable(),
  category_id: z.string().optional().nullable(),
  organization_id: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  updated_at: z.string().optional().nullable(),
}).strict();

export const CreateProductTagSchema = z.object({
  firestoreId: z.string().optional(),
  name: z.string(),
  color: z.string().optional(),
  icon: z.string().optional(),
  categoryId: z.string().optional(),
});

export const UpdateProductTagSchema = z.object({
  name: z.string().optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  categoryId: z.string().optional(),
});

// Type exports
export type ProductTagResponse = z.infer<typeof ProductTagResponseSchema>;
export type CreateProductTag = z.infer<typeof CreateProductTagSchema>;
export type UpdateProductTag = z.infer<typeof UpdateProductTagSchema>;

// API factory function
export function createProductTagsApi(client: TypedApiClient) {
  return {
    getProductTags: (params?: {
      categoryId?: string;
    }): Promise<ProductTagResponse[]> => {
      return client.get('/product-tags', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(ProductTagResponseSchema),
      });
    },

    createProductTag: (data: CreateProductTag): Promise<ProductTagResponse> => {
      CreateProductTagSchema.parse(data);
      return client.post('/product-tags', {
        data,
        responseSchema: ProductTagResponseSchema,
      });
    },

    updateProductTag: (id: string, data: UpdateProductTag): Promise<ProductTagResponse> => {
      return client.patch(apiPath`/product-tags/${id}`, {
        data,
        responseSchema: ProductTagResponseSchema,
      });
    },
  };
}
